<dx-tab-panel
    [showNavButtons]="true"
>
    <dxi-item title="ServiceAndProductMapping">
        <div *dxTemplate="let data of 'serviceAndProductMapping'">
            <dx-data-grid
                    [dataSource]="productsData"
                    [showBorders]="true"
                    [columnAutoWidth]="true"
                    [allowColumnResizing]="true"
                    [columnResizingMode]="'widget'"
                    [allowColumnReordering]="true"
            >
                <dxo-paging [pageSize]="5"></dxo-paging>
                <!-- Columns Configuration -->
                <dxi-column dataField="BarcodeMappingId"></dxi-column>
                <dxi-column dataField="BarcodeMappingModeId"></dxi-column>
                <dxi-column dataField="BrandId"></dxi-column>
                <dxi-column dataField="BrandName"></dxi-column>
                <dxi-column dataField="CategoryId"></dxi-column>
                <dxi-column dataField="CategoryName"></dxi-column>
                <dxi-column dataField="CleanBarcode"></dxi-column>
                <dxi-column dataField="CompanyId"></dxi-column>
                <dxi-column dataField="CompanyName"></dxi-column>
                <dxi-column dataField="CurrentProductMasterId"></dxi-column>
                <dxi-column dataField="IsValidBarcode"></dxi-column>
                <dxi-column dataField="IsVerifiedBarcode"></dxi-column>
                <dxi-column dataField="MasterBrandId"></dxi-column>
                <dxi-column dataField="MasterBrandName"></dxi-column>
                <dxi-column dataField="PackagingTypeId"></dxi-column>
                <dxi-column dataField="PackagingTypeName"></dxi-column>
                <dxi-column dataField="Position"></dxi-column>
                <dxi-column dataField="ProductBarcodeId"></dxi-column>
                <dxi-column dataField="ProductId"></dxi-column>
                <dxi-column dataField="ProductIsDiscontinued"></dxi-column>
                <dxi-column dataField="ProductIsMensProduct"></dxi-column>
                <dxi-column dataField="ProductIsNatureInspired"></dxi-column>
                <dxi-column dataField="ProductMasterId"></dxi-column>
                <dxi-column dataField="ProductMasterIsActive"></dxi-column>
                <dxi-column dataField="ProductMasterIsDiscontinued"></dxi-column>
                <dxi-column dataField="ProductName"></dxi-column>
                <dxi-column dataField="ProductSizeOnLabel"></dxi-column>
                <dxi-column dataField="ServiceAndProductMappingId"></dxi-column>
                <dxi-column dataField="ServiceAndProductMappingModeId"></dxi-column>
                <dxi-column dataField="SourceBarcode"></dxi-column>
                <dxi-column dataField="SourceBrand"></dxi-column>
                <dxi-column dataField="SourceCategory"></dxi-column>
                <dxi-column dataField="SourceCompany"></dxi-column>
                <dxi-column dataField="SourceDescription"></dxi-column>
                <dxi-column dataField="SourceMasterBrand"></dxi-column>
                <dxi-column dataField="SourcePackagingType"></dxi-column>
                <dxi-column dataField="SourceSize"></dxi-column>
                <dxi-column dataField="SourceSizeAsNumeric"></dxi-column>
                <dxi-column dataField="SourceSubBrand"></dxi-column>
                <dxi-column dataField="SourceSubcategory"></dxi-column>
                <dxi-column dataField="SourceUnitOfMeasure"></dxi-column>
                <dxi-column dataField="SubBrandId"></dxi-column>
                <dxi-column dataField="SubBrandName"></dxi-column>
                <dxi-column dataField="SubcategoryFormId"></dxi-column>
                <dxi-column dataField="SubcategoryFormName"></dxi-column>
                <dxi-column dataField="SubcategoryFunctionId"></dxi-column>
                <dxi-column dataField="SubcategoryFunctionName"></dxi-column>
            </dx-data-grid>
        </div>
    </dxi-item>
</dx-tab-panel>
